import { useEffect } from 'react';

// The head to emit while a page is still resolving what it is.
//
// Deliberately NO title: an empty or placeholder title must not fire the
// prerender readiness ping (SeoHelmet only signals on a real one, and the
// renderer waits up to 12s for it). The 503 meta is the other half of the
// contract - if the render still times out, server.js answers 503 and nginx
// does not cache it, where a bare loading state used to be captured as a
// 200 with no title, no canonical and no robots and served for 7 days.
//
// Written to the DOM directly, NOT through react-helmet. Measured live on
// 2026-09-22: as a <Helmet> child, this meta stayed in <head> after the
// component had unmounted - every API call done, the navigation rendered,
// the page's own SeoHelmet in place - and the renderer answered 503 for a
// complete page. react-helmet recomputes its tags from the instances still
// mounted, and an unmount alone did not reliably produce a commit that
// removed the tag. A plain element added on mount and removed in the effect
// cleanup cannot be left behind. It carries no data-react-helmet attribute,
// so react-helmet never touches it either.
const PendingHead = () => {
  useEffect(() => {
    const meta = document.createElement('meta');

    meta.setAttribute('name', 'prerender-status-code');
    meta.setAttribute('content', '503');
    meta.setAttribute('data-pending-head', 'true');
    document.head.appendChild(meta);

    return () => {
      meta.remove();
    };
  }, []);

  return null;
};

export default PendingHead;
